"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransactionId = void 0;

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _random2 = _interopRequireDefault(require("lodash/random"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var getTransactionId = function getTransactionId() {
  var transactionId = (0, _random2["default"])(1, true).toString(36).substr(2, 9);
  Sentry.configureScope(function (scope) {
    scope.setTag('transaction_id', transactionId);
  });
  return transactionId;
};

exports.getTransactionId = getTransactionId;